import { OdataManager } from '@/api/odata/odata-manager';
import { DynamicDocumentItem } from '@/api/model/interfaces';

export default class DynamicDocumentItemOdata extends OdataManager<DynamicDocumentItem> {}
